<template>
  <div class="ma-4 d-flex flex-column ga-3">
    <v-card
      v-for="agreement in agreements"
      :key="agreement.id"
      border
      tile
    >
      <v-card-text>
        <v-row>
          <v-col class="d-flex align-center">
            <div>
              <router-link
                :to="{ query: { agreementId: agreement.id } }"
                class="c-primary underlined pointer"
              >
                {{ agreement.name }}
              </router-link>

              <div class="fs-14">
                <LongDateTime
                  :date="agreement.sent_at"
                  prefix="Sent:"
                />
              </div>
            </div>
          </v-col>

          <v-col class="d-flex align-center justify-end">
            <AgreementStatus :agreement="agreement" />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <NullState
      v-if="!agreements || agreements.length === 0"
      title="No agreements assigned"
      hide-new-button
    />

    <AgreementDialog
      @change="emit('change')"
      :role="role"
    />
  </div>
</template>

<script setup>
import AgreementDialog from '@/shared/components/agreement/AgreementDialog.vue';
import AgreementStatus from '@/shared/components/agreement/AgreementStatus.vue';
import LongDateTime from '@/shared/components/LongDateTime.vue';
import NullState from '@/shared/components/NullState.vue';

defineProps({
  agreements: {
    type: Array,
    default: () => [],
  },
  role: {
    type: String,
    required: true,
  },
});

const emit = defineEmits(['change']);
</script>
